import React from 'react';
import styles from './TcsoDualFuelResultsScreen.module.css';
import { XrinvData, XritmResponseData } from '../../types/comms-check';

export const AddressSection: React.FC<{ address: string }> = ({ address }) => (
  <>
    <div className={styles.sectionHeading}>Address</div>
    <div className={styles.sectionText}>{`Address: ${address}`}</div>
  </>
);

interface ReadingsSectionProps {
  heading: string;
  xritm: XritmResponseData;
}

export const ReadingsSection: React.FC<ReadingsSectionProps> = ({ heading, xritm }) => (
  <>
    <div className={styles.sectionHeading}>{heading}</div>
    <div className={styles.sectionText}>{xritm.msn}</div>
    {xritm.data.map(({ registerId, reading }) => (
      <div key={registerId} className={styles.sectionText}>{`${registerId}: ${reading}`}</div>
    ))}
  </>
);

export const DeviceListSection: React.FC<{ devices: XrinvData[] }> = ({ devices }) => (
  <>
    <div className={styles.sectionHeading}>Comms hub device list</div>
    {devices.map((device) => (
      <div key={device.deviceId}>
        <div className={styles.sectionHeading}>{device.deviceType}</div>
        <div className={styles.sectionText}>{`Status: ${device.deviceStatus}`}</div>
        <div className={styles.sectionText}>{`GUID: ${device.deviceId}`}</div>
        {device.lastCommunicatedTime ? (
          <div className={styles.sectionText}>{`LCT: ${device.lastCommunicatedTime}`}</div>
        ) : (
          <div className={styles.sectionText}>{`Asset Type: ${device.smetsDeviceType}`}</div>
        )}
      </div>
    ))}
  </>
);
